import { useState } from "react";
import { ShoppingBag } from "lucide-react";
import { useCartTotals } from "../../lib/cart";
import { formatPrice } from "../../data/siteData";
import { scrollToTarget } from "../../lib/lenis";
import { OfferInline } from "../site/OfferBanner";
import { CartLine } from "./CartLine";
import { OrderForm } from "./OrderForm";
import { OrderReview } from "./OrderReview";

const toPanelTop = () => scrollToTarget(document.getElementById("panier"), -90);

export const CartPanel = () => {
  const { items, total, count, pizzaCount } = useCartTotals();
  const [review, setReview] = useState(null);
  const [form, setForm] = useState(null);
  const openReview = ({ form: f, details }) => {
    setForm(f);
    setReview(details);
    toPanelTop();
  };
  const edit = () => {
    setReview(null);
    toPanelTop();
  };
  return (
    <div id="panier" className="rounded-3xl border border-[#D4A359]/25 bg-[#123322] p-6 sm:p-8 scroll-mt-28" data-testid="cart-panel">
      <div className="flex items-center justify-between gap-4">
        <h2 className="font-display text-3xl flex items-center gap-3"><ShoppingBag className="w-6 h-6 text-[#D4A359]" strokeWidth={1.4} /> Votre panier</h2>
        {count > 0 && <span className="text-sm text-[#D6CFC0]" data-testid="cart-count">{count} article{count > 1 ? "s" : ""}</span>}
      </div>
      <div className="mt-5"><OfferInline count={pizzaCount} testId="cart-offer" /></div>
      {items.length === 0 && <p className="mt-8 text-[#D6CFC0]" data-testid="cart-empty">Votre panier est vide. Ajoutez une pizza ou des pâtes pour commencer.</p>}
      {items.length > 0 && review && <OrderReview items={items} total={total} pizzaCount={pizzaCount} details={review} onEdit={edit} />}
      {items.length > 0 && !review && (
        <>
          <ul className="mt-2">{items.map((i) => <CartLine key={i.key} item={i} />)}</ul>
          <div className="mt-5 flex items-baseline justify-between">
            <span className="text-sm uppercase tracking-[0.2em] text-[#D4A359]">Total TTC</span>
            <span className="font-display text-4xl text-[#F7F4EB]" data-testid="cart-total">{formatPrice(total)}</span>
          </div>
          <OrderForm initial={form} onReview={openReview} />
        </>
      )}
    </div>
  );
};
